import axios from "axios";
import stalwartApiCall from "../../utilities/stalwartCommonApi";
import configUrlObj from "../../Configuration";

const jocataPreApproved = (data) => {

    // var reqObj = {
    //     "header": {
    //         "authToken": configUrlObj.authToken[configUrlObj.environment],
    //         "productName": productName
    //     },
    //     "body": {
    //         "mobileNumber": mobileNo
    //     }
    // }
    return new Promise((resolve, reject) => {
        // axios.post('/shaft/api/db/get-credit-score-details/v1', data).then(response => {
        stalwartApiCall('POST', data, '/partner/creditscore/api/services/jocata/jocata-pre-approved').then(response => {
            resolve(response.data);
        }).catch(error => {
            reject(error);
        })
    });
}

export default jocataPreApproved;



